<template>
  <div>
    <el-row :gutter="24" type="flex" justify="end" class="search-flights-row">
      <el-col v-for="i in inputs" :key="i.field" :xs="12" :sm="6" :lg="4">
        <el-input v-model="searchData[i.field]" :placeholder="i.text" />
      </el-col>
      <el-col :xs="12" :sm="6" :lg="4">
        <el-select
          v-if="canAction('flightsAccess')"
          v-model="searchData.payments_status"
          placeholder="Статус оплаты"
          clearable
        >
          <el-option
            v-for="item in paidOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :xs="12" :sm="6" :lg="4">
        <loader-wrapper :loading="loadingExp">
          <el-select
            v-model="searchData.has_acts"
            placeholder="Наличие акта"
            clearable
          >
            <el-option
              v-for="item in actOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </loader-wrapper>
      </el-col>
      <el-col :xs="12" :sm="6" :lg="4">
        <loader-wrapper :loading="loadingExp">
          <el-select
            v-model="searchData.org_client_id"
            placeholder="Экспортер"
            clearable
          >
            <el-option
              v-for="item in exporters"
              :key="item.id"
              :label="item.short_name"
              :value="item.id"
            />
          </el-select>
        </loader-wrapper>
      </el-col>
      <el-col v-for="i in dates" :key="i.field" :xs="12" :sm="6" :lg="4">
        <el-date-picker
          v-model="searchData[i.field]"
          type="date"
          :placeholder="i.text"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
        />
      </el-col>

      <el-col :xs="12" :sm="6" :lg="4">
        <loader-wrapper :loading="loadingExp">
          <el-select
            v-model.number="searchData.freight_id"
            placeholder="Тип груза"
            clearable
          >
            <el-option
              v-for="item in cultures"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </loader-wrapper>
      </el-col>

      <el-col :xs="12" :sm="6" :lg="4">
        <loader-wrapper
          v-if="isAdminOrCeoRole || isDispatcherRole"
          :loading="loadingExp"
        >
          <el-select
            v-model="searchData.is_tudatka"
            placeholder="Тудатка"
            clearable
          >
            <el-option
              v-for="item in tudatkaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </loader-wrapper>
      </el-col>

      <el-col :xs="12" :sm="6" :lg="4">
        <el-button type="primary" @click="onSearch">Поиск</el-button>
      </el-col>
      <el-col :xs="12" :sm="6" :lg="4">
        <el-button type="primary" plain @click="onClear">
          Сбросить фильтры
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="24" type="flex" class="search-flights-row">
      <el-col v-if="count" :xs="12" :sm="6" :lg="4" class="flights-count">
        <loader-wrapper
          :loading="loading"
          spinner="el-icon-loading"
          background="rgba(249,249,249,.9)"
        >
          Найдено <b>{{ count }}</b> рейсов
        </loader-wrapper>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { pickerOpt } from '@/datas/consts'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'SearchFlights',
  components: { LoaderWrapper },
  data() {
    return {
      actOptions: [
        { value: '1', label: 'Есть акт' },
        { value: '0', label: 'Нет акта' },
      ],
      inputs: [
        { field: 'ttn_number', text: 'Номер ТТН' },
        { field: 'act_number', text: 'Номер Акта' },
        { field: 'state_numbers', text: 'Номер Авто' },
        { field: 'carrier_name', text: 'Наименование ИП' },
        { field: 'carrier_inn', text: 'ИНН ИП' },
      ],
      paidOptions: [
        { value: 'payed', label: 'Оплачен' },
        { value: 'unpayed', label: 'Не оплачен' },
      ],
      dates: [
        { field: 'load_day_from', text: 'искать с' },
        { field: 'load_day_before', text: 'искать по' },
      ],
      pickerOptions: pickerOpt,
      tudatkaOptions: [
        { value: '1', label: 'Тудатки' },
        { value: '0', label: 'Не тудатки' },
      ],
      searchData: {
        ttn_number: '',
        act_number: '',
        state_numbers: '',
        carrier_name: '',
        carrier_inn: '',
        payments_status: '',
        org_client_id: '',
        has_acts: '',
        freight_id: '',
        is_tudatka: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      pagination: 'responses/getPagination',
      getLoading: 'responses/getLoading',
      exporters: 'responses/getExporters',
      getLib: 'libs/getLib',
    }),
    loadingExp() {
      return this.getLoading('Exp')
    },
    loading() {
      return this.getLoading()
    },
    count() {
      return this.pagination && this.pagination.totalCount
        ? this.pagination.totalCount
        : 0
    },
    cultures() {
      return this.getLib('freightTypes')
    },
  },
  created() {
    this.$store.dispatch('responses/fetchExporters')
  },
  methods: {
    onSearch() {
      this.$emit('search', this.searchData)
    },
    onClear() {
      for (let key in this.searchData) {
        this.searchData[key] = ''
      }
      this.$emit('search')
    },
  },
}
</script>

<style lang="sass">
.search-flights-row
  flex-wrap: wrap
  .el-col
    margin-bottom: 20px
    .el-date-editor.el-input
      width: 100%
    input
      height: 52px
    button
      height: 52px
      width: 100%
    &.flights-count
      display: flex
      align-items: center
      font-size: 16px
      color: #00BF4E
      .el-loading-spinner
        margin-top: -10px
</style>
